import React, { useEffect, useState } from "react";
import { isFirefox, isSafari } from "react-device-detect";

function WarningBanner() {
  const [messages, setMessages] = useState([]);

  useEffect(() => {
    const warnings = [];

    // 🔧 Manual override
    const forceLowMem = localStorage.getItem("lowmem") === "true";

    // 🧠 Memory check
    const memory = navigator.deviceMemory;

    console.log("[WarningBanner] deviceMemory:", memory);
    console.log("[WarningBanner] Firefox:", isFirefox);
    console.log("[WarningBanner] Safari:", isSafari);

    if (forceLowMem || (memory && memory <= 4)) {
      warnings.push(
        "Your device is below the recommended minimum system specs. You may experience issues loading or running your virtual therapy space."
      );
    }

    // 🌐 Browser compatibility
    if (isFirefox || isSafari) {
      warnings.push(
        "Not all Plutonic features are currently supported in Firefox or Safari. For the best experience, please use Chrome or Edge."
      );
    }

    setMessages(warnings);
  }, []);

  if (messages.length === 0) return null;

  return (
    <div className="warning-banner">
      {messages.map((msg, index) => (
        <div key={index} style={{ marginBottom: "4px" }}>
          ⚠️ {msg}
        </div>
      ))}
    </div>
  );
}

export default WarningBanner;